module.exports = __webpack_public_path__ + "img/contact_img2.a22bd00c.png";